import moment from 'moment-timezone';

moment.updateLocale('en', {
  relativeTime: {
    'future': 'in %s',
    'past': '%s ago',
    's': 'a few seconds',
    'ss': '%d seconds',
    'm': 'a minute',
    'mm': '%d minutes',
    'h': 'an hour',
    'hh': '%d hours',
    'd': 'a day',
    'dd': '%d days',
    'w': 'a week',
    'ww': '%d weeks',
    'M': 'a month',
    'MM': '%d months',
    'y': 'a year',
    'yy': '%d years',
  },
});

moment.updateLocale('en-short', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: '%ds',
    ss: '%ds',
    m: '1 min',
    mm: '%d mins',
    h: '1 hr',
    hh: '%d hrs',
    d: '1 day',
    dd: (num) => {
      const isCurrentyear = moment().subtract(num, 'days').year() === moment().year();
      const isMoreThan7Days = num > 7;

      if (!isCurrentyear) {
        return moment().subtract(num, 'days').format('MMM. D, YYYY');
      }

      if (isCurrentyear && isMoreThan7Days) {
        return moment().subtract(num, 'days').format('MMM. D');
      }

      return num + ' days';
    },
    w: '1w',
    ww: '%dw',
    M: '1M',
    MM: '%dM',
    y: '1y',
    yy: '%dy',
  },
});

moment().tz('UTC');

// Least number of seconds to be considered a minute
moment.relativeTimeThreshold('s', 60);
// Least number of minutes to be considered an hour
moment.relativeTimeThreshold('m', 60);
// Least number of hours to be considered a day
moment.relativeTimeThreshold('h', 24);
// Least number of days to be considered a month (week is not set by default)
moment.relativeTimeThreshold('d', Number.MAX_SAFE_INTEGER);

export default moment;
